import { ReactElement, ReactNode } from 'react'
import {
  Button,
  colors,
  radius,
  Separator,
  shadows,
  Text,
} from '../../index.js'

type AuthContainerProps = {
  subtitle?: ReactNode
  title?: ReactNode
  children: ReactNode
  trailComponent?: ReactNode
}

// This component should probably become a generic
// centered panel

export const AuthContainer = ({
  subtitle,
  title,
  children,
  trailComponent,
}: AuthContainerProps) => {
  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        background: colors.neutralInverted100,
        position: 'relative',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          background: `linear-gradient(transparent, transparent 45%, ${colors.neutral10Adjusted})`,
        }}
      />
      <div
        style={{
          animation: '600ms tilt-soft cubic-bezier(0.30,-0.00,0.60,1.10)',
          margin: '0 auto',
          position: 'relative',
          background: colors.neutralInverted100,
          borderRadius: radius[24],
          border: `1px solid ${colors.neutral10}`,
          boxShadow: `${shadows.popoverLarge}`,
          width: '100%',
          maxWidth: 400,
          padding: '32px 24px',
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: 8,
            flexDirection: 'column',
            padding: '0 6px',
          }}
        >
          {typeof subtitle === 'string' ? (
            <Text variant="display-medium" color="neutral60">
              {subtitle}
            </Text>
          ) : subtitle ? (
            subtitle
          ) : null}
          {title && (
            <Text variant="heading-medium" color="neutral100">
              {title}
            </Text>
          )}
        </div>
        {children}
        {trailComponent}
      </div>
    </div>
  )
}
